/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FilterTypes {
    DataTransferObject = '0',
    Custom = 1,
    Grouped = 2,
}
